module.exports = __webpack_public_path__ + "hbomaxar-static/media/q-mark.273b7bd1.svg";